import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import ProfesionalPrestaciones from "../components/ProfesionalPrestaciones";
import { UserContext } from "../services/UserContext";
import { API, authHeaders } from "../services/config";
import "./PrestacionesPage.css";

export default function ProfesionalPrestacionesPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const isAdmin = user?.role === "admin";

  const [profesional, setProfesional] = useState(null);

  useEffect(() => {
    if (!isAdmin && String(user?.profesional?.id) !== String(id)) {
      navigate("/profesionales", { replace: true });
    }
  }, [id, isAdmin, user, navigate]);

  useEffect(() => {
    if (!id) return;
    fetch(`${API}/profesionales/${id}`, { headers: authHeaders() })
      .then((r) => r.json())
      .then((d) => {
        if (d.success) setProfesional(d.data);
      })
      .catch(() => {});
  }, [id]);

  if (!id) {
    navigate("/profesionales", { replace: true });
    return null;
  }

  return (
    <div className="sp-container">
      <Sidebar />
      <div className="sp-content">
        <ProfesionalPrestaciones profesionalId={id} profesional={profesional} />
      </div>
    </div>
  );
}
